var map = {
	"./cert-finance-hkgcsmeaa-sc.jpg": 404,
	"./cert-fsi-hkgcsmeaa-sc.jpg": 406,
	"./cert-general-staff-a-hkgcsmeaa-sc.jpg": 408,
	"./cert-general-staff-hkgcsmeaa-sc.jpg": 410,
	"./cert-general2024-hkgcsmeaa-sc.jpg": 338,
	"./cert-senior-manager-hkgcsmeaa-sc.jpg": 416,
	"./cert-student-hkgcsmeaa-sc.jpg": 419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3374;